import { useDataChange } from 'Simple/Data.js'

import subDays from 'date-fns/subDays/index.js'
import startOfDay from 'date-fns/startOfDay/index.js'
import endOfDay from 'date-fns/endOfDay/index.js'

import { dateShortOut } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let changeSelected = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onChange(value, change) {
    let start_date = value.from || startOfDay(subDays(new Date(), 30))
    let end_date = value.to || endOfDay(new Date())

    if (!value.from && !value.to) {
      change(next => {
        next.to = end_date
        next.from = start_date
      })
    }

    // sync up the value
    changeSelected(inext => {
      inext.selected.range.start_date = dateShortOut(start_date)
      inext.selected.range.end_date = dateShortOut(end_date)
    })
  }
}
